/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';
import { handleArrowKeydown } from '../utils/carousel-helpers';

const CarouselNextArrow = ({ onClick }) => {
  return (
    <div
      alt="carousel-next-arrow"
      onClick={onClick}
      onKeyDown={e => handleArrowKeydown(e, onClick)}
      className="carousel-next-arrow"
      role="button"
      tabIndex={0}
      aria-label="next item button"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Next Location Arrow</title>
        <circle
          r="12"
          transform="matrix(-1 0 0 1 12 12)"
          fill={'var(--primary-brand-font-color)'}
        />
        <path
          d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM16.1438 12.1741L9.55446 16.942C9.4125 17.0438 9.21429 16.942 9.21429 16.7679V15.5116C9.21429 15.2384 9.34554 14.9786 9.56786 14.8179L13.4625 12L9.56786 9.18214C9.34554 9.02143 9.21429 8.76429 9.21429 8.48839V7.23214C9.21429 7.05804 9.4125 6.95625 9.55446 7.05804L16.1438 11.8259C16.2616 11.9116 16.2616 12.0884 16.1438 12.1741Z"
          fill={'var(--primary-brand-color)'}
        />
      </svg>
    </div>
  );
};

export default React.memo(CarouselNextArrow);
